import { useEffect, useState } from 'react';
import { getClientIdGTM } from "@utils/cookie";
import { getCookiesPolicy, postUserConsent } from '@libraries/api/policy/policy.repos';
import { useLanguage } from "@utils/useLanguage";
import { setOpenSnackbar } from '@redux/slices/rootSnackbar';
import store from '@redux/store';
import { ICookieConsent, ICookieConsentDetails } from '../type';

const useAction = () => {
  const [show, setShow] = useState(false);
  const [isOpenDetail, setIsOpenDetail] = useState(false);
  const [dataConsent, setDataConsent] = useState<ICookieConsentDetails | null>(null);
  const [isLoadingDetail, setIsLoadingDetail] = useState(false);

  const clientGTM = getClientIdGTM();
  const { language } = useLanguage();

  const onClickConsent = async (isConsent: boolean) => {
    try {
      const payload: ICookieConsent = {
        clientIdGTM: clientGTM || '',
        necessary: true,
        marketing: isConsent,
        performance: isConsent,
        statistic: true,
        targeting: true,
        version: dataConsent?.version || '',
      };
      const res = await postUserConsent(payload);

      if (res) {
        localStorage.setItem('localConsentId', JSON.stringify(payload));
        setIsOpenDetail(false);
        setShow(false);
      }
    } catch (error) {
      store.dispatch(setOpenSnackbar({
        message: 'Failed to save your cookie preferences. Please try again.',
        variant: 'error',
        duration: 4000,
        anchor: 'top-center',
      }));
      throw error;
    };
  };

  const toggleDetail = () => {
    setIsOpenDetail(!isOpenDetail);
  };

  const getDataConsent = async () => {
    setIsLoadingDetail(true);
    try {
      const { data } = await getCookiesPolicy(language);
      setDataConsent(data);
    } catch (error) {
      return false;
    } finally {
      setIsLoadingDetail(false);
    }
  };

  useEffect(() => {
    const localConsent = typeof window !== 'undefined' ? localStorage.getItem('localConsentId') : '';

    if (dataConsent) {
      const parseLocalConsent = localConsent ? JSON.parse(localConsent) : {};
      if (
        (Object.keys(parseLocalConsent).length && !clientGTM) ||
        (parseLocalConsent?.clientIdGTM === clientGTM &&
          parseLocalConsent?.version === dataConsent?.version)
      ) {
        setShow(false);
      } else {
        setShow(true);
      }
    }
  }, [clientGTM, dataConsent]);

  useEffect(() => {
    getDataConsent();
  }, [language]);

  return {
    show,
    isOpenDetail,
    dataConsent,
    isLoadingDetail,
    onClickConsent,
    toggleDetail,
  };
};

export default useAction;
